  <template>
  <div class="users-style">
  	<div v-if="success != ''" class="alert alert-success" role="alert"> {{success}} </div>
    <div style="float: right; text-align: right;">
  <a class="btn btn-primary" style="color: #FFFFFF;"  @click="displaypayrunmodal()">+Add Minimum Tax</a>
  </div>
  <br />
 
    
   	<h2>Minimum Tax</h2>
	<table class="table table-bordered table-striped table-hover" v-if="pending_payruncount!=0">
	  <thead>
		<tr style="border-top: 1px solid #dee2e6;">
		  <td>Fiscal year</td>
          <td>Zone Type</td>
		  <td>Minimum Amount</td>
          <td>Created On</td>
		  <td></td>
		</tr>
	  </thead>
	  <tbody>
		<tr v-for="trule in minimumtax" :key="trule.id">
          <td>{{trule.fiscal_year}}</td>
          <td>{{trule.zone_type}}</td>
		  <td>{{trule.min_tax}}</td>
          <td>{{trule.created_at}}</td>
		  <td style="min-width: 190px;"><a class="btn btn-primary" style="color: #FFFFFF;"  @click="get_min_tax_by_id(trule.id, 'no')">View</a> <a class="btn btn-primary" style="color: #FFFFFF;"  @click="get_min_tax_by_id(trule.id, 'yes')">Edit</a></td>
		</tr>
	  </tbody>
	  <tfoot>
		<tr>
		  <td colspan="9"><span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span>
			<button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.prebuttonstatus" @click="setPagination(false)" > Prev </button>
			<button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.nextbuttonstatus"   @click="setPagination(true)"> Next </button>
			<select class="input" type="text" v-model="per_page" @change="setSearch()">
			  <option value="5">5</option>
			  <option value="10">10</option>
			  <option value="20">20</option>
			</select></td>
		</tr>
	  </tfoot>
	</table>
    

    
 <div>
  <b-modal id="minimumtax_modal" title="Add Minimum Tax"  size="lg" hide-footer>  
  <!-- Modal Content Starts -->
  <b-card style="margin: 0 30px 30px 30px;">
	<form @submit="formSubmit" enctype="multipart/form-data">
	  <input class="input" type="hidden" v-model="id" >

	  <div class="form-group row">
		<label for="name" class="col-md-4 col-form-label">Fiscal Year</label>
		<div class="col-md-12">
		  <select id="fiscal_year" v-model="fiscal_year" name="fiscal_year" required class="form-control ">
          <option v-for='pyr in payrunyears'  :value='pyr.range'>{{ pyr.range }}</option>
		  </select>
		</div>
	  </div>
      
   	  <!--<div class="form-group row">
		<label for="name" class="col-md-4 col-form-label">Zone Title</label>
		<div class="col-md-12">
		<input id="title" type="text" class="form-control" required v-model="zone_title" name="title">
		</div>
	  </div>-->  
      

   	  <div class="form-group row">
		<label for="name" class="col-md-4 col-form-label">Zone Type</label>
		<div class="col-md-12">
		<!--<input id="zone_type" type="text" class="form-control" required v-model="zone_type" name="zone_type">-->
        <select class="form-control" required v-model="zone_type" name="zone_type">
			  <option value="City Corporation">City Corporation</option>
			  <option value="Municipality">Municipality</option>
			  <option value="Rural Area">Rural Area</option>
		</select>
        
        
		</div>
	  </div>  
 
      <div class="form-group row">
		<div class="col-md-4">Minimum Tax Amount</div>
		<div class="col-md-12">
		<input id="min_tax" type="text" class="form-control" required v-model="min_tax" name="min_tax">
		</div>
	  </div> 

 


	  <div class="form-group row">
		<div class="col-md-2">
		  <button class="btn btn-primary btn-full-width" v-if="show_submit=='yes'">Submit</button>
		</div>
        
        <div class="col-md-2" v-if="loading =='load'">
          <img :src="$api_url+'/images/loading.gif'" width="30">
        </div>
        
	  </div>
	</form>
</b-card>
    
  <!-- Modal Content Ends -->
  </b-modal>
</div>   
  </div>
  
  </template> 
  <script>
	  export default{
		  props: [ 'company_name'],
		  mounted() {
			  console.log('started..');            
		  },
		  data(){
			  return {
				  minimumtax : [], 
                  payrunyears: [],
				  pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                  search_by_id: {id:''},
				  per_page:10,               
				  
                  company_title: this.company_name,
                  pending_payruncount:0,

                  success: '',
				  id: '',
				  month: '',
				  year: '',
                  loading:'',

                  fiscal_year: '',
                  zone_title: '',
                  zone_type: '',
                  min_tax: '',
                  show_submit: '',

			  }
		  },
		  methods:{
		      
 		  	  getpayrunyears: function()
			  {
  
						  axios.get(this.$api_url+'/getfiscalyears' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.payrunyears = response.data;
  
  
				  }.bind(this));
			  },

              
              displaypayrunmodal: function()
			  {
                this.success= '';
                this.month='';
                this.year='';
                this.show_submit='yes';
                
                        this.fiscal_year= '';
                        this.zone_title= '';
                        this.zone_type= '';
                        this.min_tax= '';
                
			    this.$bvModal.show('minimumtax_modal');
              },
              
              
                 formSubmit(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
  
                  this.loading='load';
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
  
                  let formData = new FormData();

                  formData.append('fiscal_year', this.fiscal_year);
                  formData.append('zone_title', this.zone_title);
                  formData.append('zone_type', this.zone_type);
                  formData.append('min_tax', this.min_tax);
  
				  axios.post(this.$api_url+'/minimumtaxtorevue', formData, config)
  
				  .then(function (response) {
                      currentObj.loading='';
					  currentObj.success = response.data.success;
                      currentObj.$bvModal.hide('minimumtax_modal');
                      currentObj.getminimumtax();
                      
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });
  
			  },

			
			  setSearch: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
				  this.getminimumtax();
                 
			  },
			  setPagination: function(pageflg)
			  {                
				  if(pageflg)
					  this.pagination.currentPage = this.pagination.nextPage;
				  else    
					  this.pagination.currentPage = this.pagination.prevPage;
				  
				  this.getminimumtax();
			  },
			  getminimumtax: function()
			  {
			        //this.search_by_id.id=1;
  
						  axios.get(this.$api_url+'/list-minimumtax/1/0' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								 // search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					   
                       //alert(response.data.data[0]['id']);
                       
					  this.minimumtax = response.data.data;
                      this.pending_payruncount=this.minimumtax.length;
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },
              
              
              
			  get_min_tax_by_id: function(id, show_button_flag)
			  {
			        this.search_by_id.id=id;
                    this.show_submit=show_button_flag;
  
						  axios.get(this.$api_url+'/list-minimumtax/1/0' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					   
                       //alert(response.data.data[0]['id']);
                        
                        this.fiscal_year= response.data.data[0]['fiscal_year'];
                        this.zone_title= response.data.data[0]['zone_title'];
                        this.zone_type= response.data.data[0]['zone_type'];
                        this.min_tax= response.data.data[0]['min_tax'];
                        this.$bvModal.show('minimumtax_modal');
                        
				  }.bind(this));
			  },
              
		  },
          
		  created: function(){
		      this.getpayrunyears();
			  this.getminimumtax();
              
		
		  }
	  }
  </script>
  <style>
  button.disabled{
	  cursor: default;
  }
  
  .tb-border{
    border: 1px solid #808080;
    border-radius: 0.25rem !important;
    border-collapse: separate;
}

.tb-border td{
    padding: 2px !important;
}
  
  </style>